export default "__VITE_ASSET__CsmAFJz___"